function PromoTerms() {
  return (
    <div className="min-h-screen  py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-green-dark border shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold  mb-8 text-center">
            Watchful Referral Program Terms & Conditions
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-6">
            <section>
              <h2 className="text-lg font-semibold  mb-4">Eligibility</h2>
              <p className="text-gray-300 leading-relaxed">
                To refer or be referred, you must be a real human, not a bot, camera, or unusually clever seagull. 
                You must also be located somewhere on planet Earth (bonus points if it's New Zealand).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold  mb-4">What Counts as a Successful Referral</h2>
              <p className="text-gray-300 leading-relaxed">
                A "successful referral" occurs when your referred person (the "Friend") signs up to Watchful and 
                keeps the camera connected and operational. No unplugging it immediately after. We'll know. The camera must be in a working state, transmitting events and footage as intended, and not useless in nature ( ie: pointing at an unused fish tank or directly against a blank wall. )
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold  mb-4">The Reward</h2>
              <p className="text-gray-300 leading-relaxed">
                Once that camera has connected, both you and your Friend will each earn $1,000 NZD. 
                Payment method is usually bank transfer. Rewards are 
                non-transferable, non-refundable, and cannot be redeemed for snacks, hugs, or alternate dimensions 
                of value.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold  mb-4">Limits & Fair Play</h2>
              <p className="text-gray-300 leading-relaxed">
                You can refer as many people as you like, but Watchful reserves the right to question any 
                suspicious activity, such as referring yourself under a fake moustache, setting up 10 cameras 
                in your shed, or involving time travel to trigger multiple rewards.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold  mb-4">Timing & Changes</h2>
              <p className="text-gray-300 leading-relaxed">
                We may pause, tweak, or terminate this program at any time, because, well, life happens. Any 
                referrals already confirmed before such changes will still be honoured.
              </p>
            </section>


            <section>
              <h2 className="text-lg font-semibold  mb-4">Good Faith Clause</h2>
              <p className="text-gray-300 leading-relaxed">
                This offer is meant to spread the word about Watchful, not test the limits of human creativity 
                in finding loopholes. Please don't make us write more legalese.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold  mb-4">Contact Us</h2>
              <p className="text-gray-300 leading-relaxed">
                Got questions? Reach out to the Watchful team. If your query starts with "technically…" we 
                reserve the right to sigh audibly before replying.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t  text-center">
            <p className="text-sm 0">
              © {new Date().getFullYear()} Watchful. These terms are subject to change without notice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoTerms;
